var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 41.5453,
    cy: 51.35,
    r: 9.03161,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.6738 78.8979L66.8339 44.5778L85.2622 42.8227L87.6066 42.7715L88.9613 44.5778V47.2873L63.2212 96.058L60.5118 97.4127L58.7054 96.5095L49.6738 78.8979Z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.9033 25.1602L20.7738 27.4181L8.12958 51.3518L2.71062 46.836L0.904297 41.417L4.06536 33.7402L9.03274 26.5149L14.9033 25.1602Z",
    fill: "url(#paint2_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92384 56.8302C5.01425 57.1157 5.21435 57.3533 5.4806 57.4911L49.0095 80.0398C49.0304 80.0507 57.2114 95.9749 57.2114 95.9749C57.9545 97.417 59.4242 98.3144 61.0465 98.3161H61.0514C62.6716 98.3161 64.1412 97.4225 64.8865 95.9837L89.8222 47.8735C90.5686 46.4331 90.4506 44.7159 89.5135 43.3913C88.5775 42.0666 86.9998 41.3842 85.3902 41.6074L67.7381 43.8102C67.8444 43.8652 67.6557 43.7267 67.7381 43.8102L48.4008 33.788V5.92592C48.4008 2.65812 45.7427 0 42.4749 0H39.9359C36.6681 0 34.0099 2.65812 34.0099 5.92592V26.3292L24.2528 21.2719C23.9871 21.1335 23.6779 21.1081 23.3923 21.198C23.1068 21.2884 22.8692 21.4885 22.7314 21.7548L20.5411 25.9808L18.989 25.1764C13.8464 22.51 7.43478 24.6345 4.69949 29.9127L1.23544 36.596C-1.49986 41.8731 0.459833 48.336 5.60353 51.0018L7.15558 51.8064L4.99771 55.9697C4.8599 56.2354 4.83344 56.5452 4.92384 56.8302ZM85.7022 43.8433C86.4789 43.7386 87.2165 44.0533 87.6702 44.695C88.1244 45.3366 88.1795 46.1365 87.8179 46.8349L62.8822 94.9452C62.5205 95.642 61.8364 96.0582 61.0515 96.0582H61.0493C60.2632 96.057 59.5785 95.6392 59.218 94.9408C59.218 94.9408 50.9303 78.9351 50.8469 78.8529L67.731 46.2771C67.8463 46.2981 85.7022 43.8433 85.7022 43.8433ZM41.2048 43.4877C45.6203 43.4877 49.2123 47.0797 49.2123 51.4946C49.2123 55.9101 45.6203 59.5021 41.2048 59.5021C36.7899 59.5021 33.1979 55.9101 33.1979 51.4946C33.198 47.0797 36.7899 43.4877 41.2048 43.4877ZM39.9359 2.25792H42.4749C44.4975 2.25792 46.1429 3.90339 46.1429 5.92592V42.5004C44.6767 41.6922 42.9942 41.2298 41.2048 41.2298C39.4159 41.2298 37.7338 41.6919 36.2679 42.4998V5.92592C36.2679 3.90339 37.9133 2.25792 39.9359 2.25792ZM24.2165 23.796L33.9719 28.8521C33.9841 28.8584 33.9976 28.8571 34.0099 28.863V44.185C32.1175 46.048 30.94 48.6354 30.94 51.4946C30.94 57.1549 35.5446 61.76 41.2048 61.76C46.8651 61.76 51.4702 57.1549 51.4702 51.4946C51.4702 48.6358 50.293 46.0487 48.4008 44.1858V36.3307L65.6968 45.2953L49.0023 77.5053L7.52188 56.0061L24.2165 23.796ZM6.64264 48.9975C2.60419 46.9038 1.07778 41.807 3.23978 37.6346L6.70383 30.9512C8.86748 26.7805 13.9136 25.0882 17.9499 27.1807L19.502 27.9854L8.19455 49.8018L6.64264 48.9975Z",
    fill: "url(#paint3_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.3932 55.5566L23.4011 60.2257C23.567 60.3117 23.7445 60.3525 23.9193 60.3525C24.3278 60.3525 24.7219 60.1303 24.9226 59.7428C25.2098 59.1893 24.9937 58.508 24.4397 58.2213L15.4317 53.5523C14.8788 53.2661 14.1975 53.4817 13.9103 54.0351C13.6231 54.5886 13.8392 55.2699 14.3932 55.5566Z",
    fill: "url(#paint4_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.8893 50.7403L25.8972 55.4094C26.0631 55.4954 26.2406 55.5362 26.4154 55.5362C26.8239 55.5362 27.218 55.314 27.4186 54.9265C27.7058 54.3731 27.4898 53.6917 26.9358 53.4051L17.9278 48.736C17.3749 48.4493 16.6936 48.666 16.4064 49.2189C16.1192 49.7723 16.3352 50.4537 16.8893 50.7403Z",
    fill: "url(#paint5_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90.2717 77.1173C90.0202 77.6878 90.2785 78.354 90.8495 78.6056L98.6592 82.0471C99.2303 82.2988 99.8962 82.0398 100.148 81.4693C100.399 80.8988 100.141 80.2326 99.5697 79.9809L91.76 76.5395C91.189 76.2878 90.5231 76.5468 90.2717 77.1173Z",
    fill: "url(#paint6_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.3725 99.1066C87.5379 98.7313 87.4924 98.2794 87.216 97.9389L81.8377 91.3117C81.445 90.8278 80.7342 90.7538 80.2503 91.1466C79.7664 91.5393 79.6929 92.2503 80.0854 92.7347L85.4637 99.3618C85.8564 99.8457 86.5671 99.9198 87.0511 99.527C87.1952 99.4104 87.3027 99.265 87.3725 99.1066Z",
    fill: "url(#paint7_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.8638 60.7858C95.9005 61.4079 96.4347 61.8825 97.0568 61.8459L105.577 61.3432C106.015 61.3175 106.379 61.0461 106.544 60.6708C106.614 60.5124 106.649 60.335 106.638 60.1499C106.601 59.5277 106.067 59.0532 105.445 59.0898L96.9246 59.5924C96.3022 59.6296 95.8261 60.1632 95.8638 60.7858Z",
    fill: "url(#paint8_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.5769,
    y1: 42.3184,
    x2: 32.5137,
    y2: 60.3816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 88.9613,
    y1: 42.7715,
    x2: 37.1641,
    y2: 80.0141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20.7738,
    y1: 25.1602,
    x2: -4.44923,
    y2: 44.2949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 90.3093,
    y1: 0,
    x2: -7.6531,
    y2: 89.9845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 25.0496,
    y1: 53.4258,
    x2: 18.8688,
    y2: 63.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 27.5457,
    y1: 48.6094,
    x2: 21.3647,
    y2: 58.6628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 90.7269,
    y1: 76.0842,
    x2: 89.8106,
    y2: 80.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 80.3838,
    y1: 90.5348,
    x2: 81.8742,
    y2: 100.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 97.9834,
    y1: 55.6657,
    x2: 99.4735,
    y2: 65.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowEmpty);
export default __webpack_public_path__ + "static/media/follow-empty.0e6cba031be0787dab8ce4838ce78e57.svg";
export { ForwardRef as ReactComponent };